<template>
  <div>
    <div class="text-center">
      <h2  class="font-weight-light">Add Payment Method</h2>
    </div>
    <v-card
      class="mx-auto mt-5"
      max-width="400"
      outlined>

      <!-- Used to display form errors. -->
      <v-alert
        v-if="hasErrors()"
        color="warning">
        <ul>
          <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
        </ul>
      </v-alert>

      <v-card-text
        class="mt-5 mb-5"
      >
        <div class="sr-input sr-element sr-card-element" id="card-element">
          <!-- A Stripe card Element will be inserted here. -->
        </div>
      </v-card-text>

      <v-card-actions>
        <v-btn
          to="/payment-methods"
          rounded
          outlined
          color="grey"
          dark>
          Back
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          @click.prevent="savePaymentMethod()"
          :loading="loading"
          rounded
          color="info">
          Add Card
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "PaymentMethodsAdd",
  data() {
    return {
      errors: [],
      stripe: '',
      setupIntentClientSecret: null,
      setupIntent: null,
      elements: '',
      card: '',
      publicToken: '',
      loading: false
    }
  },
  computed: {
    ...mapState([
      "continueHref"
    ]),
    user() {
      return this.$store.state.user
    },
    hasDefaultPaymentMethod() {
      return this.$store.state.hasDefaultPaymentMethod
    },
  },
  mounted() {
    this.$axios.get(this.$cfg.ACCOUNTS_API_URL + 's/pk')
      .then((response) => {
        // A reference to Stripe.js initialized publishable API key.
        this.stripe = window.Stripe(response.data)
      })
      .then(()=>{
        this.configureStripe()
      })
      .catch((error) => {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          this.errors = error.response.data.errors
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          this.errors = ["Network error"]
        } else {
          // Something happened in setting up the request that triggered an Error
          this.errors = ["We're really sorry our systems seems to be unhealty now. Please try again later or contact us."]
        }
      })
  },
  methods: {
    hasErrors() {
      return this.errors.length > 0
    },
    configureStripe() {
      // eslint-disable-next-line no-undef
      this.elements = this.stripe.elements();

      // Element styles
      var style = {
        base: {
          fontSize: "16px",
          color: "#32325d",
          fontFamily:
            "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
          fontSmoothing: "antialiased",
          "::placeholder": {
            color: "rgba(0,0,0,0.4)"
          }
        }
      };
      
      this.card = this.elements.create("card", { style: style });
      // this.card = this.elements.create("card");
      this.card.mount("#card-element");

      // Element focus ring
      this.card.on("focus", function() {
        var el = document.getElementById("card-element");
        el.classList.add("focused");
      });

      this.card.on("blur", function() {
        var el = document.getElementById("card-element");
        el.classList.remove("focused");
      });
    },
    async savePaymentMethod(){
      this.errors = []
      try {
        this.loading = true
        // get setup intent client secret
        await this.$axios.get(this.$cfg.ACCOUNTS_API_URL + 's/setup-intents').then(response => {
                this.setupIntentClientSecret = response.data
              })

        // Save payment method to Stripe
        await this.stripe.confirmCardSetup(this.setupIntentClientSecret, {
                payment_method: {
                  card: this.card,
                  billing_details: { name: this.user.FullName }
                },
                expand: ['payment_method']
              })
              .then(result => {
                if (result.error) {
                  this.errors.push(result.error.message)
                } else {
                  this.setupIntent = result.setupIntent
                }
              })

        if (this.errors.length == 0 ){
          // if no default payment method set this card as default
          if (!this.hasDefaultPaymentMethod) {
            await this.$axios.post(this.$cfg.ACCOUNTS_API_URL + 's/customers/set-default-payment-method', {id: this.setupIntent.payment_method.id})
          }

          // refresh our store
          await this.$axios.get(this.$cfg.ACCOUNTS_API_URL + 's/customers/check-default-payment-method')
                .then(response => {
                  this.$store.dispatch("setDefaultPaymentMethod", response.data)
                })

          this.$store.dispatch("addNotification", {
            type: 'success',
            message: 'The payment method was successfully saved'
          })

          if (this.continueHref) {
            this.$router.push({ name: this.continueHref })
          } else {
            this.$router.push({ name: 'payment-methods' })
          }
          this.errors = []
        }
      } catch(error) {
        this.$store.dispatch("addNotification", {
          type: "error",
          message: error,
        });
        console.log("error", error);
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
